import api from "./instance";
import urls from "./urls";

const { movieDB } = urls;

export default {
  getCategoryList: async token => {
    const categories = api.get(`/categories`, {
      headers: { Authorization: token }
    });
    const data = Promise.all([categories]);

    return data;
  },
  getCategory: async (id, token) => {
    const categories = api.get(`/categories/${id}`, {
      headers: { Authorization: token }
    });
    const data = Promise.all([categories]);

    return data;
  },
  createCategory: async (token, payload) => {
    const res = await api.post(`/categories`, payload, {
      headers: { Authorization: token }
    });
    return res;
  },
  patchCategory: async (token, payload, id) => {
    const res = await api.patch(`/categories/${id}`, payload, {
      headers: { Authorization: token }
    });
    return res;
  },
  deleteCategory: async (id, token) => {
    const res = await api.delete(`/categories/${id}`, {
      headers: { Authorization: token }
    });
    return res;
  }
};
